import React, { forwardRef } from "react";
import { Formik, Form, Field, ErrorMessage, type FormikProps } from "formik";
import * as Yup from "yup";
import DragAndDropUpload from "../../../DragAndDropUpload";

interface Props {
  initialValues: any;
  onNext: (values: any) => void;
}

const schema = Yup.object({
  businessName: Yup.string().required("Business name is required"),
  website: Yup.string().matches(/((https?):\/\/)?(www\.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(\/[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    'Enter a valid URL!').nullable(),
  description: Yup.string().nullable(),
  logo: Yup.string().nullable(), // now a URL from Cloudinary
});

const BusinessForm: React.FC<Props> = forwardRef<FormikProps<any>, Props>(({ initialValues, onNext }, ref) => {

  return (
    <Formik
      innerRef={ref}
      initialValues={{
        businessName: initialValues.businessName || "",
        website: initialValues.website || "",
        description: initialValues.description || "",
        logo: initialValues.logo || "",
      }}
      validationSchema={schema}
      // validateOnChange={false}
      onSubmit={(values) => {
        onNext(values);
      }}
    >
      {({ isSubmitting }) => (
        <Form className="space-y-4">
          <div>
            <label className="form-label">Business name</label>
            <Field name="businessName" className="form-input" />
            <ErrorMessage
              name="businessName"
              component="div"
              className="text-xs text-red-500 mt-1"
            />
          </div>

          <div>
            <label className="form-label">Website <span className="text-gray-400 text-xs font-normal">(optional)</span></label>
            <Field name="website" className="form-input" />
            <ErrorMessage
              name="website"
              component="div"
              className="text-xs text-red-500 mt-1"
            />
          </div>

          <div>
            <label className="form-label">Description <span className="text-gray-400 text-xs font-normal">(optional)</span></label>
            <Field
              component="textarea"
              name="description"
              className="form-input h-24"
            />
            <ErrorMessage
              name="description"
              component="div"
              className="text-xs text-red-500 mt-1"
            />
          </div>

          {/* ✅ IMAGE UPLOAD FIELD */}
          <div>
            <DragAndDropUpload name="logo" label="Upload Logo" />
          </div>

          <div className="flex justify-end">
            <button
              type="submit" // important!
              className="form-btn-mini"
              disabled={isSubmitting}
            >
              Next
            </button>
          </div>

        </Form>
      )}
    </Formik>
  );
});

export default BusinessForm;
